<script setup>
	import { storeToRefs } from 'pinia';
	import { useUserStore } from "@/store/modules/user";
	import { useAppStore } from "@/store/modules/app";
	import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
	import en from 'element-plus/dist/locale/en.mjs';

	const appStore  = useAppStore();
	const { site }  = storeToRefs(appStore);
	const userStore = useUserStore();
	userStore.getUser();

	const locale = ref({});
	if(site.value.lang.current?.code == "zh-cn"){
		locale.value = zhCn;
	}else{
		locale.value = en;
	}
</script>

<template>
	<el-config-provider :locale="locale">
		<router-view />
	</el-config-provider>
</template>

<style lang="scss">

</style>
